import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import img from '../images/calendly.webp'
import { useTranslation } from 'react-i18next';
import { getProfileField } from '../translations/profileTranslation';



function AppoinetementEdit({ dragHandleProps }) {


  const { t } = useTranslation();

  const [AppointementModal, setAppointementModal] = useState(false)
  const [EditAppointementModal, setEditAppointementModal] = useState(false)
  let LanguageSelected = Cookies.get('LanguageSelected');

  const [Done, setDone] = useState(false)
  const [InputsErrors, setInputsErrors] = useState([])
  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');

  const [apointementInfo, setApointementInfo] = useState('')

  const [ApointementId, setApointementId] = useState()


  const [ApointementContent, setApointementContent] = useState([])
  const [isFetching, setIsFetching] = useState(false);

  const [ProfileContent, setProfileContent] = useState([])


  useEffect(() => {
    fetch(`${apiUrl}/GetProfileInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`
  
  
      },
      body: JSON.stringify({ user_id: userId })
  
  
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setProfileContent(result.data)
        }
      })
  },[])
  const SetApoinetementToUpdateDefaultValues = () => {
    const Apointement = ApointementContent[0]
    return setApointementInfo(Apointement.link_calendly)

  }
  useEffect(() => {
    if (AppointementModal || EditAppointementModal ) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [AppointementModal,EditAppointementModal]);


  const apiUrl = process.env.REACT_APP_BACKEND_URL


  useEffect(() => {
    fetch(`${apiUrl}/GetAppoinetementInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setApointementContent([result.data])

        }
      })
  }, [Done])

  const StoreAppoinetementInfo = (e) => {
    setIsFetching(true);

    e.preventDefault()
    fetch(`${apiUrl}/StoreAppoinetementInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ link_calendly: apointementInfo, user_id: userId })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setApointementInfo('')
          setDone(!Done)
          setInputsErrors([])
          setAppointementModal(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });


  }

  const UpdateAppoinetementInfo = (e) => {
    setIsFetching(true);


    e.preventDefault()
    fetch(`${apiUrl}/UpdateAppoinetementInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ link_calendly: apointementInfo, ApointementId: ApointementId })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setApointementInfo('')
          setInputsErrors([])
          setDone(!Done)
          setEditAppointementModal(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });

  }

  const DeleteAppoinetementInfo = (e, id) => {
    e.preventDefault()

    fetch(`${apiUrl}/DeleteAppoinetementInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ ApointementId: id })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setDone(!Done)

        }
      })
  }

  return (
    <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>
      <section className="booking  sections rounded-xl pt-3 pb-3 pl-3 m-3">
        <div className='flex justify-between'>
          <div className="">
            <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-4' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>{t("Prise de rendez-vous")}
            </h1>
          </div>
          {ApointementContent != '' &&

            ApointementContent.map(Apointement => {
              return (

                <div className="flex  items-center -mt-5">
                  <svg onClick={() => { setEditAppointementModal(true); setApointementId(Apointement.id); SetApoinetementToUpdateDefaultValues() }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                  </svg>
                  <svg onClick={(e) => { DeleteAppoinetementInfo(e, Apointement.id) }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 mr-0.5' : 'w-6 mr-5'}`}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                  </svg>
                </div>
              )
            })

          }
        </div>



        {ApointementContent != '' &&

          ApointementContent.map(Apointement => {
            return (


              <div className="p-3 mr-2">
                <div className="flex justify-between  items-center ">
                  <div className="flex items-center gap-3">
                  <div className='ml-2 flex items-center justify-center bg-white p-1 rounded h-14 w-24 mr-2  rounded-lg'>
                      <img src={img} className="w-14 " alt />

                    </div>

                    <div className="text-about space-y-2">
                      {t("Cliquez ici pour prendre rendez-vous avec moi ")}{getProfileField(ProfileContent, 'first_name', LanguageSelected)}        </div>
                  </div>
                  <div>
                    {LanguageSelected == "ar" ?
                      (
                        <a href={Apointement.link_calendly}>

                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                          </svg>


                        </a>
                      )
                      :
                      (
                        <a href={Apointement.link_calendly}>

                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                          </svg>


                        </a>
                      )



                    }

                  </div>

                </div>
              </div>


            )
          })

        }


        {ApointementContent == '' &&

          <a onClick={() => { setAppointementModal(true) }}>

            <main className="flex p-5  items-center justify-center ">
              <label htmlFor="dropzone-file-appointement" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded border-2 border-dashed border-gold div-sections  p-6 text-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="mt-2 text-about tracking-wide"> {t("Entrez vos informations de prise de rendez-vous.")}</p>
              </label></main></a>}


        <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path fill-rule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clip-rule="evenodd" />
          </svg>

        </div>
      </section>


      {AppointementModal &&

        <div>

          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setAppointementModal(false); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl mb-2 text-theme ">{t("Prise de rendez-vous")}
              </h2>
              <form className="space-y-6 text-about">
                <div>
                  <label htmlFor="email" className="textModaltext-black">{t("Offrez à vos rencontres la possibilité de réserver un créneau disponible sur votre agenda en quelques clics")}</label>
                  <div className="mt-5">
                    <input onChange={(e) => setApointementInfo(e.target.value)} type="email" id="email" name="email" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer Votre lien de  Calendly")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('link_calendly') && InputsErrors.link_calendly}</span></p>

                  </div>
                </div>
                <div className="how-link " style={{fontSize:'17px'}}>
                  <p>{t("Comment obtenir votre lien")}<a href="http://www.youtube.com/watch?v=MB6Wp72s4Ow&t=3s" className="link text-blue-500" target='_blank' > Cliquez ici !</a></p>
                </div>
                <button onClick={(e) => { StoreAppoinetementInfo(e) }} disabled={isFetching} type="submit" className="w-full btn-edit">
                  {t("enregistrer")}
                </button>
              </form></div>
          </div>
        </div>


      }


      {EditAppointementModal &&

        <div>

          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setEditAppointementModal(false); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl mb-2  text-theme">{t("Prise de rendez-vous")}
              </h2>
              <form className="space-y-6 text-about">
                <div>
                  <label htmlFor="email" className="textModal text-black">{t("Offrez à vos rencontres la possibilité de réserver un créneau disponible sur votre agenda en quelques clics")}</label>
                  <div className="mt-5">
                    <input defaultValue={ApointementContent[0].link_calendly} onChange={(e) => setApointementInfo(e.target.value)} type="text" id="link" name="link" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer Votre lien de  Calendly")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('link_calendly') && InputsErrors.link_calendly}</span></p>

                  </div>
                </div>
                <div className="how-link " style={{fontSize:'17px'}} >
                  <p> {t("Comment obtenir votre lien")}<a href="http://www.youtube.com/watch?v=MB6Wp72s4Ow&t=3s" className="link text-blue-500"> Click Here !</a></p>
                </div>
                <button onClick={(e) => { UpdateAppoinetementInfo(e) }} disabled={isFetching} type="submit" className="w-full btn-edit">
                  {t("enregistrer")}
                </button>
              </form></div>
          </div>
        </div>


      }



    </div>
  )
}

export default AppoinetementEdit